import { CtaStackSlice } from '@adapters/prismic/types/landingPage';
import Container from '@components/global/Container';
import Button from '@components/ui/Button';
import Heading from '@components/ui/Heading';

import styles from './CtaStack.module.scss';

interface CtaStackProps {
  primary: CtaStackSlice['primary'];
  items: CtaStackSlice['items'];
  locale?: string;
}

const CtaStack = ({ primary, items, locale }: CtaStackProps) => (
  <section>
    <Container>
      {primary?.title && (
        <Heading semanticLevel="h2" styleLevel="2" className={styles.heading}>
          {primary?.title}
        </Heading>
      )}
      <div className={styles.container}>
        {items?.map((item) => (
          <Button
            key={`cta-stack-${item?.title}`}
            variant={item.variant}
            label={item?.title}
            href={`/${locale}/${item?.link}`}
            size="large"
            className={styles.button}
          />
        ))}
      </div>
    </Container>
  </section>
);

export default CtaStack;
